// extracted by mini-css-extract-plugin
export default {"modalContent":"SaveAsModal_modalContent__NlkAT"};